import { FAQ_FAQ_QUESTION_SET_DATA, FAQ_FAQ_QUESTION_RESET_DATA } from 'rebook/apps/faq/constants';


const initialState = {
  questionSlug: null,
  title: null,
  content: null,
  sectionSlug: null,
};

export default function faqQuestion(state = initialState, action) {
  switch (action.type) {
    case FAQ_FAQ_QUESTION_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case FAQ_FAQ_QUESTION_RESET_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
